import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  IFreshmanConfigurationData,
  IMainSteps,
  IMainTasks,
  ISubTasks,
  IFreshmanConfigurationEdit,
} from "../../../../../../models/freshman/configuration";
import { getAllMainStepsKeyValuePair } from "../../../../../../action/freshman/mainstepActionCreator";
import {
  getAllSubStepsKeyValuePair,
  getSubSteps,
} from "../../../../../../action/freshman/subStepActionCreator";
import {
  booleanOptions,
  cloneDeep,
} from "../../../../../../constants/commonConstants";
import FloatingLabelDropDown from "../../../../../../common-components/floatingdropdown";
import {
  getAllStudentType,
  getColleges,
} from "../../../../../../action/common/commonActionCreator";
import FloatingLabelTextInput from "../../../../../../common-components/floatingtextinput";
import { updateFreshmanConfiguration } from "../../../../../../action/freshman/configurationActionCreator";
import {
  alertConstants,
  getAlertData,
} from "../../../../../../helper/sweet-alert";
import LoaderSpinner from "../../../../../../common-components/loader";
import SweetAlert from "react-bootstrap-sweetalert";
import Joi from "joi";
import { validateFields } from "../../../../../../helper/joi-validation";
import FreshmanConfigurationMainTask from "./freshmanConfigurationMainTask";

const FreshmanConfigurationEdit = (props: IFreshmanConfigurationEdit) => {
  const {
    mainSteps,
    subSteps,
    getMainSteps,
    getSubSteps,
    setShowEdit,
    CollegeId,
    getCampus,
    studentType,
    getAllStudentType,
    getAllSubSteps,
    allSubSteps,
    freshmanUpdateConfiguration,
    freshmanData,
    getAllConfiguration,
  } = props;

  const [selectedMainStep, setSelectedMainStep] = useState<number>(
    freshmanData?.mainSteps?.length
      ? freshmanData.mainSteps[0].mainStepId ?? 0
      : 0
  );
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [loading, setLoading] = useState<boolean>(false);
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>(undefined);
  const isInternationalOptions = Object.entries(booleanOptions).map(
    ([key, value]) => ({
      id: value,
      name: key,
    })
  );

  let mainTasks: IMainTasks = {
    mainTask: [],
  };

  let subTasks: ISubTasks = {
    subTask: [],
  };

  const [data, setData] = useState<IFreshmanConfigurationData>(
    cloneDeep(freshmanData || {})
  );
  const [mainTaskData, setMainTaskData] = useState<IMainTasks>(mainTasks);
  const [subTaskData, setSubTaskData] = useState<ISubTasks>(subTasks);
  const [mainStepOrder, setMainStepOrder] = useState<number>(0);

  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
    mainStepId?: number,
    subStepId?: number
  ) => {
    const { name, value } = event.target;
    const _data = { ...data, [event.target.name]: event.target.value };
    if (errors && errors[name]) {
      const updatedErrors = { ...errors };
      delete updatedErrors[name];
      setErrors(updatedErrors);
    }
    setData(_data);
  };

  const onMainChange = (event: any) => {
    if (event.target.name === "mainSteps") {
      const _mainTasks = Array.from(event.target.value);
      let updatedMainStep = _mainTasks.map((mt: any, index: number) => ({
        id: mt,
        order: index + 1,
        prerequisites: [],
        subSteps: [],
        name: mainSteps.find((ms) => ms.id == mt)?.name,
      }));
      setMainTaskData({ ...mainTaskData, mainTask: updatedMainStep });
    } else if (event.target.name === "mainStepPredecessor") {
      const stepIndex = mainTaskData.mainTask?.findIndex(
        (mt) => mt.id === selectedMainStep
      );
      let task = mainTaskData.mainTask;

      task[stepIndex] = {
        ...task[stepIndex],
        prerequisites: event.target.value,
      };

      setMainTaskData({ ...mainTaskData, mainTask: task });
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const schema = Joi.object({
    studentType: Joi.number().required().label("Select Program Type"),
    isInternational: Joi.boolean()
      .required()
      .label("Select International Or Not"),
    email: Joi.string()
      .trim()
      .regex(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      .required()
      .label("Enter valid email"),
    collegeId: Joi.number().required().label("Select University Management"),
    mainSteps: Joi.array().min(1).required().label("Select Main Tasks"),
  });

  const onUpdate = async () => {
    const trimmedData = {
      ...data,
      email: data.email?.trim(),
    };
    const updatedMainSteps: IMainSteps[] = mainTaskData.mainTask.map(
      (mainStep) => ({
        mainStepId: mainStep.id ?? undefined,
        order: mainStep.order ?? undefined,
        prerequisites: mainStep.prerequisites ?? [],
        subSteps: subTaskData.subTask
          .filter((subStep) => subStep.mainStepId === mainStep.id)
          .map((subStep) => ({
            subStepId: subStep.id ?? 0,
            prerequisites: subStep.prerequisites ?? [],
            order: subStep.order ?? undefined,
            percentage: 0,
            url: subStep.url,
          })),
        totalPercentage: 0,
      })
    );

    const urlValidation = subTaskData.subTask.some((ss) => ss.errors);
    const validationErrors = validateFields(
      { ...trimmedData, mainSteps: updatedMainSteps },
      schema
    );

    if (validationErrors === undefined && !urlValidation) {
      setLoading(true);
      try {
        await freshmanUpdateConfiguration(
          { ...trimmedData, mainSteps: updatedMainSteps },
          freshmanData.id ?? 0,
          setAlert
        );
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const initialLoading = async () => {
    await getMainSteps();
    await getSubSteps();
    getCampus();
    getAllStudentType();
    getAllSubSteps(true);
  };

  useEffect(() => {
    initialLoading();
    if (freshmanData) {
      const _mainSteps = freshmanData.mainSteps.map((ms) => ({
        id: ms.mainStepId ?? null,
        order: ms.order ?? null,
        prerequisites: ms.prerequisites,
        subSteps: [],
        name: ms.mainStepName ?? "",
      }));
      setMainTaskData({ ...mainTaskData, mainTask: _mainSteps });

      const _subSteps = freshmanData.mainSteps?.flatMap(
        (ms) =>
          ms.subSteps?.map((subStep) => ({
            mainStepId: ms.mainStepId ?? null,
            id: subStep.subStepId ?? null,
            order: subStep.order ?? null,
            url: subStep.url,
            prerequisites: subStep.prerequisites,
            name: subStep.name,
          })) || []
      );
      setSubTaskData({ ...subTaskData, subTask: _subSteps });
    }
  }, []);

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
      setShowEdit(false);
    } else {
      getAllConfiguration();
      setShowEdit(false);
    }
  };

  useEffect(() => {
    if (mainTaskData.mainTask.length > 0 && errors?.mainSteps) {
      const updatedErrors = { ...errors };
      delete updatedErrors.mainSteps;
      setErrors(updatedErrors);
    }
  }, [mainTaskData.mainTask.length]);

  const handleMainStep = (mainStepId: number) => {
    setSelectedMainStep(mainStepId);
    const order =
      mainTaskData.mainTask?.find((ms) => ms.id == mainStepId)?.order ?? 0;
    setMainStepOrder(order);
  };

  return (
    <>
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
          Update Freshman Process
        </h1>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => setShowEdit(false)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-lg-3 form-group">
            <FloatingLabelDropDown
              label={"Program Level "}
              onChange={onChange}
              isMandatory={true}
              value={data.studentType}
              name={"studentType"}
              optionsList={studentType}
              placeholder={"Select Program Level"}
            />
            {errors?.studentType && (
              <div className="text-danger">{errors.studentType}</div>
            )}
          </div>
          <div className="col-lg-3 form-group">
            <FloatingLabelDropDown
              label={"International Student "}
              onChange={onChange}
              isMandatory={true}
              value={data.isInternational}
              name={"isInternational"}
              optionsList={isInternationalOptions}
              placeholder={"Select option"}
            />
            {errors?.isInternational && (
              <div className="text-danger">{errors.isInternational}</div>
            )}
          </div>
          <div className="col-lg-3 form-group">
            <FloatingLabelDropDown
              label={"University Management"}
              onChange={onChange}
              isMandatory={true}
              value={data.collegeId}
              name={"collegeId"}
              optionsList={CollegeId}
              placeholder={"Select University Management"}
            />
            {errors?.collegeId && (
              <div className="text-danger">{errors.collegeId}</div>
            )}
          </div>
          <div className="col-lg-3 form-group">
            <FloatingLabelTextInput
              label={"Email Config "}
              onChange={onChange}
              isMandatory={true}
              value={data.email}
              name={"email"}
              maxLength={50}
              placeholder={"Email"}
            />
            {errors?.email && <div className="text-danger">{errors.email}</div>}
          </div>
          <div className="col-lg-12 d-flex fresman-config">
            <FreshmanConfigurationMainTask
              mainTaskData={mainTaskData}
              selectedMainStep={selectedMainStep}
              setSubTaskData={setSubTaskData}
              subTaskData={subTaskData}
              subSteps={subSteps}
              setMainTaskData={setMainTaskData}
              mainSteps={mainSteps}
              errors={errors}
              handleMainStep={handleMainStep}
              allSubSteps={allSubSteps}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={onUpdate}>
          Update
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => setShowEdit(false)}
        >
          Close
        </button>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowEdit(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {loading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  getMainSteps: getAllMainStepsKeyValuePair,
  getSubSteps: getAllSubStepsKeyValuePair,
  getCampus: getColleges,
  getAllStudentType: getAllStudentType,
  getAllSubSteps: (includeInactive?: boolean) => getSubSteps(includeInactive),
  freshmanUpdateConfiguration: (
    data: IFreshmanConfigurationData,
    studentCategoryId: number,
    callBack: Function
  ) => updateFreshmanConfiguration(data, studentCategoryId, callBack),
};

function mapStateToProps(state: any) {
  return {
    mainSteps: state.mainStep.keyValuePair,
    subSteps: state.subStep.keyValuePair,
    CollegeId: state.common.colleges,
    studentType: state.common.studentType,
    allSubSteps: state.subStep.subSteps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreshmanConfigurationEdit);
